module.exports = __webpack_public_path__ + "static/img/step-3.8215db5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer2/step-3.png
// module id = hmDe
// module chunks = 1